<template>
  <a-drawer
    title="订单动作记录"
    placement="right"
    width="80%"
    :visible="innerVisible"
    @close="close"
    destroyOnClose>
    <a-card :bordered="false">
      <!-- 搜索条 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="类型">
                <a-select v-model="queryParam.type" placeholder="请选择" allow-clear>
                  <a-select-option v-for="item in typeOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.state" placeholder="请选择" allow-clear>
                  <a-select-option v-for="item in stateOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"> <a-icon type="search" />查询 </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"> <a-icon type="redo" />重置 </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作条 -->
      <div class="table-operations">

        <a-button type="primary" @click="handleExport" v-hasPermi="['c4023b894a61205cceae45d003a05ff5e:0:e']">
          <a-icon type="download" />导出
        </a-button>
      </div>

      <!-- 表格 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="type" slot-scope="text">
          <a-tag :color="getTypeColor(text)">{{ getTypeText(text) }}</a-tag>
        </span>
        <span slot="state" slot-scope="text">
          <a-tag :color="getStateColor(text)">{{ getStateText(text) }}</a-tag>
        </span>
        <span slot="handleUserId" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="optionContent" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="description" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="handleDescription" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="createTime" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleViewDetail(record)" v-hasPermi="['c4023b894a61205cceae45d003a05ff5q:0:q']"> 详情 </a>
          <!-- <a-divider type="vertical" v-if="record.state === 0 || record.state === 1" />
          <a
            v-if="record.state === 0 || record.state === 1"
            @click="handleProcessAction(record)"
            v-hasPermi="['upkeep:order-action:process']"
          >
            处理
          </a>
          <a-divider type="vertical" v-if="record.state === 0 || record.state === 1" />
          <a
            v-if="record.state === 0 || record.state === 1"
            @click="handleCancelAction(record)"
            v-hasPermi="['upkeep:order-action:cancel']"
          >
            取消
          </a> -->
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 新建动作弹窗 -->
    <a-modal
      title="新建订单动作"
      :visible="createModalVisible"
      @ok="handleCreateOk"
      @cancel="handleCreateCancel"
      :confirmLoading="createLoading"
      width="600px"
    >
      <a-form :form="createForm" layout="vertical">
        <a-form-item label="动作类型">
          <a-select
            v-decorator="['type', { rules: [{ required: true, message: '请选择动作类型' }] }]"
            placeholder="请选择动作类型"
          >
            <a-select-option v-for="item in typeOptions" :key="item.value" :value="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="选项内容">
          <a-input v-decorator="['optionContent']" placeholder="请输入选项内容" />
        </a-form-item>
        <a-form-item label="描述说明">
          <a-textarea
            v-decorator="['description', { rules: [{ required: true, message: '请输入描述说明' }] }]"
            placeholder="请输入描述说明"
            :rows="4"
          />
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea v-decorator="['remark']" placeholder="请输入备注" :rows="2" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 处理动作弹窗 -->
    <a-modal
      title="处理订单动作"
      :visible="processModalVisible"
      @ok="handleProcessOk"
      @cancel="handleProcessCancel"
      :confirmLoading="processLoading"
      width="600px"
    >
      <a-form :form="processForm" layout="vertical">
        <a-form-item label="处理说明">
          <a-textarea
            v-decorator="['handleDescription', { rules: [{ required: true, message: '请输入处理说明' }] }]"
            placeholder="请输入处理说明"
            :rows="4"
          />
        </a-form-item>
        <a-form-item label="处理人员">
          <a-input
            v-decorator="['handleUserId', { rules: [{ required: true, message: '请输入处理人员ID' }] }]"
            placeholder="请输入处理人员ID"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <OrderActionDetailDrawer ref="orderActionDetailDrawer" />
  </a-drawer>
</template>

<script>
import {
  fetchActionList,
  createAction,
  processAction,
  cancelAction,
} from '@/api/repairModule/orderAction'
import { tableMixin } from '@/store/table-mixin'
import OrderActionDetailDrawer from './OrderActionDetailDrawer'
export default {
  components: {
    OrderActionDetailDrawer,
  },
  name: 'OrderActionDrawer',
  mixins: [tableMixin],
  data() {
    return {
      innerVisible: false,
      createModalVisible: false,
      processModalVisible: false,
      createLoading: false,
      processLoading: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      currentRecord: null,
      currentProcessRecord: null,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        orderId: '',
        type: undefined,
        state: undefined,
      },
      typeOptions: [
        { value: 0, label: '取消订单' },
        { value: 1, label: '跟单' },
      ],
      stateOptions: [
        { value: 0, label: '发起' },
        { value: 1, label: '处理中' },
        { value: 2, label: '处理完成' },
        { value: 3, label: '取消' },
      ],
      columns: [
        {
          title: '选项内容',
          dataIndex: 'optionContent',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'optionContent' },
        },
        {
          title: '类型',
          dataIndex: 'type',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'type' },
        },
        {
          title: '状态',
          dataIndex: 'state',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'state' },
        },
        {
          title: '处理说明',
          dataIndex: 'handleDescription',
          width: 200,
          align: 'center',
          scopedSlots: { customRender: 'handleDescription' },
        },
        {
          title: '处理人员',
          dataIndex: 'handleUserId',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'handleUserId' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right',
        },
      ],
    }
  },
  beforeCreate() {
    this.createForm = this.$form.createForm(this)
    this.processForm = this.$form.createForm(this)
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.state === 2 || record.state === 3, // 已完成或已取消的记录不能选择
          },
        }),
      }
    },
  },
  methods: {
    // 打开抽屉
    open(record) {
      this.innerVisible = true
      this.currentRecord = record
      if (record && record.id) {
        this.queryParam.orderId = record.id
      }
      this.getList()
    },

    // 关闭抽屉
    close() {
      this.innerVisible = false
      this.resetQuery()
      this.onSelectChange([], [])
      this.createModalVisible = false
      this.processModalVisible = false
      this.currentRecord = null
      this.currentProcessRecord = null
    },

    // 获取类型文本
    getTypeText(type) {
      const typeMap = {
        0: '取消订单',
        1: '跟单',
      }
      return typeMap[type] || '-'
    },

    // 获取类型颜色
    getTypeColor(type) {
      const colorMap = {
        0: 'red',
        1: 'blue',
      }
      return colorMap[type] || 'default'
    },

    // 获取状态文本
    getStateText(state) {
      const stateMap = {
        0: '发起',
        1: '处理中',
        2: '处理完成',
        3: '取消',
      }
      return stateMap[state] || '-'
    },

    // 获取状态颜色
    getStateColor(state) {
      const colorMap = {
        0: 'orange',
        1: 'blue',
        2: 'green',
        3: 'red',
      }
      return colorMap[state] || 'default'
    },

    // 获取列表数据
    getList() {
      this.loading = true
      fetchActionList(this.queryParam)
        .then((response) => {
          this.list = response.data.records
          this.total = response.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 查询
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },

    // 重置查询
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        orderId: this.currentRecord?.id || '',
        type: undefined,
        state: undefined,
      }
      this.handleQuery()
    },

    // 显示新建动作弹窗
    handleCreateAction() {
      this.createModalVisible = true
      this.createForm.resetFields()
    },

    // 确认新建动作
    handleCreateOk() {
      this.createForm.validateFields((errors, values) => {
        if (!errors) {
          this.createLoading = true
          // 添加订单ID
          values.orderId = this.currentRecord.id
          createAction(values)
            .then(() => {
              this.$message.success('创建动作成功')
              this.createModalVisible = false
              this.getList()
            })
            .finally(() => {
              this.createLoading = false
            })
        }
      })
    },

    // 取消新建
    handleCreateCancel() {
      this.createModalVisible = false
    },

    // 处理动作
    handleProcessAction(record) {
      if (record) {
        // 单个处理
        this.currentProcessRecord = record
        this.processModalVisible = true
        this.processForm.resetFields()
      } else {
        // 批量处理
        const ids = this.selectedRowKeys
        if (!ids.length) {
          this.$message.warning('请选择要处理的动作记录')
          return
        }
        if (ids.length > 1) {
          this.$message.warning('请选择单条记录进行处理')
          return
        }
        // 获取选中的记录
        const selectedRecord = this.selectedRows[0]
        this.currentProcessRecord = selectedRecord
        this.processModalVisible = true
        this.processForm.resetFields()
      }
    },

    // 确认处理动作
    handleProcessOk() {
      this.processForm.validateFields((errors, values) => {
        if (!errors) {
          this.processLoading = true
          const actionId = this.currentProcessRecord.id
          processAction(actionId, values)
            .then(() => {
              this.$message.success('处理动作成功')
              this.processModalVisible = false
              this.currentProcessRecord = null
              this.onSelectChange([], [])
              this.getList()
            })
            .finally(() => {
              this.processLoading = false
            })
        }
      })
    },

    // 取消处理
    handleProcessCancel() {
      this.processModalVisible = false
      this.currentProcessRecord = null
    },

    // 取消动作
    handleCancelAction(record) {
      const ids = record ? [record.id] : this.selectedRowKeys
      if (!ids.length) {
        this.$message.warning('请选择要取消的动作记录')
        return
      }

      this.$confirm({
        title: '取消动作',
        content: `确定要取消这 ${ids.length} 条动作记录吗？`,
        onOk: () => {
          cancelAction(ids).then(() => {
            this.$message.success('取消动作成功')
            this.onSelectChange([], [])
            this.getList()
          })
        },
      })
    },

    // 查看详情
    handleViewDetail(record) {
      this.$refs.orderActionDetailDrawer.show(record)
    },

    // 导出
   handleExport() {
      const that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'upkeep/order/initiate/review/export',
            { ...that.queryParam },
            `订单动作记录表_${new Date().getTime()}.xlsx`
          )
        },
      })
    },

    // 分页大小改变
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    // 页码改变
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    // 选择行变化
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
  },
}
</script>

<style scoped>
.table-operations {
  margin-bottom: 16px;
}
.table-operations .ant-btn {
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>
